import { signedApiClient } from './apiClient';
import { StudyLink, type NetworkLinkPermissions, type NetworkStudyLink } from '@/models/studyLink';

class StudyLinkService {

  private investigationEndpoint: string = '';

  initService(investigationEndpoint: string) {
    this.investigationEndpoint = investigationEndpoint;
  }

  async getStudyLinkDetails(id: string) {
    const uri = `${this.investigationEndpoint}/${id}/link`;
    const apiClient = signedApiClient('GET', uri);
    const linkResponse = await apiClient.get(uri);
    const sharableLink: NetworkStudyLink = linkResponse.data;
    return sharableLink.link !== null ? StudyLink.mapFromBackend(sharableLink) : undefined;
  }

  async activateStudyLink(id: string) {
    const uri = `${this.investigationEndpoint}/${id}/link`;
    const apiClient = signedApiClient('POST', uri);

    const payload: NetworkLinkPermissions = {
      viewEntries: true,
      exportPermissions: false,
      manageInvestPermissions: false,
      forms: true,
      editForms: true,
      editCases: true
    };
    return await apiClient.post(uri, {
      permissions: payload
    });
  }

  async deactivateStudyLink(id: string) {
    const uri = `${this.investigationEndpoint}/${id}/link`;
    const apiClient = signedApiClient('DELETE', uri);
    return await apiClient.delete(uri);
  }

  async resetStudyLink(id: string) {
    const uri = `${this.investigationEndpoint}/${id}/link`;
    const apiClient = signedApiClient('PATCH', uri);

    const payload: NetworkLinkPermissions = {
      viewEntries: true,
      exportPermissions: false,
      manageInvestPermissions: false,
      forms: true,
      editForms: true,
      editCases: true
    };
    return await apiClient.patch(uri, {
      permissions: payload,
      resetLink: true
    });
  }

  async updateStudyLink(id: string, studyLink: StudyLink) {
    const uri = `${this.investigationEndpoint}/${id}/link`;
    const apiClient = signedApiClient('PATCH', uri);

    const payload: NetworkLinkPermissions = {
      viewEntries: studyLink.permissions.viewEntries,
      exportPermissions: studyLink.permissions.export,
      manageInvestPermissions: studyLink.permissions.manageInvest,
      forms: studyLink.permissions.forms,
      editForms: studyLink.permissions.editForms,
      editCases: studyLink.permissions.editCases
    };
    return await apiClient.patch(uri, {
      permissions: payload
    });
  }
}

export default new StudyLinkService();
